// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec25a578","239":"5a5b05d9","455":"056fcc07"}[chunkId] + ".chunk.js";
};